import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/area/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/area/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/area/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/area/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/area/update', params,options);

export const lazyTree = (params, options) =>
  request.get('/api/v4ward/area/lazyTree', Object.assign({}, options, { params }));

export const getDictionary = (code, options) =>
  request.get(
    'api/blade-system/dict/dictionary?code=' + code,
    Object.assign({}, options, {})
  );
export const lazyTreeList = (params, options) =>
  request.get('/api/v4ward/area/lazy-area-list', Object.assign({}, options, { params }));
export const lazyTreeListByParentId = (params, options) =>
  request.get('/api/v4ward/area/lazy-area-list-parentId', Object.assign({}, options, { params }));


export const treeByIds = (params, options) =>
  request.get('/api/v4ward/dept/treeByIds', Object.assign({}, options, { params }));

export const lazyTreeByProjectId = (params, options) =>
  request.get('/api/v4ward/area/lazyTreeByProjectId', Object.assign({}, options, { params }));
export const treeByProjectDeptId = (params, options) =>
  request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));

export const getAreaNodeByProjectId = (params, options) =>
  request.get('/api/v4ward/area/getAreaNodeByProjectId', Object.assign({}, options, { params }));

export const getNodeByProjectId = (params, options) =>
  request.get('/api/v4ward/area/getNodeByProjectId', Object.assign({}, options, { params }));
